import { Calendar, GraduationCap } from 'lucide-react'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { useCertificates } from '@/hooks/use-dashboard'
import { useTenantPath } from '@/lib/tenant'

export default function CertificatesPage() {
  const { data: certificates, isLoading } = useCertificates()
  const tp = useTenantPath()

  if (isLoading) {
    return (
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold mb-2">獲得証明書</h1>
          <p className="text-muted-foreground">修了したコースの証明書を確認できます</p>
        </div>
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {['skel-1', 'skel-2', 'skel-3'].map((id) => (
            <Skeleton key={id} className="h-48" />
          ))}
        </div>
      </div>
    )
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold mb-2">獲得証明書</h1>
        <p className="text-muted-foreground">修了したコースの証明書を確認できます</p>
      </div>

      {certificates && certificates.length > 0 ? (
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {certificates.map((cert) => (
            <Card key={cert.courseId} className="hover:shadow-lg transition-shadow">
              <CardHeader className="pb-4">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                  <GraduationCap className="h-6 w-6 text-emerald-600" />
                </div>
                <CardTitle className="text-lg">{cert.courseName}</CardTitle>
                <CardDescription className="flex items-center mt-2">
                  <Calendar className="h-4 w-4 mr-1" />
                  発行日:{' '}
                  {new Date(cert.issuedDate).toLocaleDateString('ja-JP', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  })}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="space-y-3">
                  <p className="text-sm text-muted-foreground">
                    このコースを正式に修了したことを証明します。
                  </p>
                  <div className="text-center">
                    <Link to={tp(`/courses/${cert.courseId}`)}>
                      <Button variant="outline" size="sm">
                        コースを確認
                      </Button>
                    </Link>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <Card className="text-center py-12">
          <CardContent>
            <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
              <GraduationCap className="h-8 w-8 text-muted-foreground" />
            </div>
            <p className="text-muted-foreground mb-4">まだ獲得した証明書はありません</p>
            <p className="text-sm text-muted-foreground mb-6">
              コースを修了すると、ここに証明書が表示されます
            </p>
            <Link to={tp('/courses')}>
              <Button>コースを探す</Button>
            </Link>
          </CardContent>
        </Card>
      )}
    </div>
  )
}
